import { TagSelect } from "client/Components";
import { TagKind, TagSaveModel } from "client/Api/Tags/tags";
import { useSuggestedTagsDataSource } from "client/Features/Tags/useSuggestedTagsDataSource";
import { IValueInputAttachable } from "client/Forms/attachable";
import { AttachTagSelectOptions } from "client/Forms/attachableProps/tagSelect";
import { AlertManager, useAlerts } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import {
	ReactElement,
	useMemo,
	useState
} from "react";

export type HubTagSelectProps = {
	attachable: IValueInputAttachable<readonly TagSaveModel[]>;
	kind: TagKind.Announcement
		| TagKind.KnowledgeItem
		| TagKind.Event;
	isDisabled: boolean;
	menuTitle: string;
};

export const HubTagSelect = (props: HubTagSelectProps): ReactElement => {
	const {
		attachable,
		kind,
		isDisabled,
		menuTitle
	} = props;

	const [searchTerm, setSearchTerm] = useState<string>("");
	const [shouldLoadTags, setShouldLoadTags] = useState<boolean>(false);

	const alertManager: AlertManager = useAlerts();

	const tagSelectOptions = useMemo(
		(): AttachTagSelectOptions => {
			return {
				onError: (message: string): void => {
					alertManager.showError(message);
				},
				maxTagCount: MAX_TAG_COUNT,
				maxTagLength: MAX_TAG_LENGTH,
				doesSupportDelete: !isDisabled
			};
		},
		[alertManager, isDisabled]
	);

	const {
		currentItems: suggestedTags,
		getLoadingState
	} = useSuggestedTagsDataSource({
		filtering: {
			selectedTagIds: attachable
				.value
				.map(x => x.id),
			count: MAX_SUGGESTED_TAG_COUNT,
			kind,
			shouldLoadData: shouldLoadTags
		},
		searchTerm: searchTerm
	});

	return (
		<TagSelect
			{...attachable.attachToTagSelect<number>(tagSelectOptions)}
			onSearch={setSearchTerm}
			searchDebounceInterval={250}
			suggestedTags={suggestedTags}
			placeholder={localize("_AddTag")}
			isDisabled={isDisabled}
			isBusy={getLoadingState() === "loading"}
			onIsSuggestionsBoxOpenChange={setShouldLoadTags}
			menuTitle={menuTitle}
		/>
	);
};
HubTagSelect.displayName = "HubTagSelect";

export const MAX_TAG_COUNT: number = 10;
export const MAX_TAG_LENGTH: number = 30;
export const MAX_SUGGESTED_TAG_COUNT: number = 20;
